
export default [
  {
    path: '/admin/loan-transfers',
    name: 'loan-transfer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/credit-operation/loan-transfer')
  }
]
